// extracted by mini-css-extract-plugin
module.exports = {"abstract":"Abstract_abstract__54qXu","info":"Abstract_info__2mBfx","title":"Abstract_title__13Oqd","row":"Abstract_row__22EB9","col":"Abstract_col__3mGt7"};